import { styled, theme } from 'ui/theme';

export const Item = styled.div`
  background: ${theme.colors.build.lightDark2};
  border-top: solid 1px ${theme.colors.build.mediumLight2};
  padding: ${theme.space[6]};

  &:last-of-type {
    margin-bottom: 0;
    border-bottom: solid 1px ${theme.colors.build.mediumLight2};
  }

  &[data-footer='false'] {
    &:last-of-type {
      border-bottom: none;
    }
  }

  &[data-header='false'] {
    &:first-of-type {
      border-top: none;
    }
  }

  &[data-alternate='true'] {
    background: ${theme.colors.build.lightDark1};
  }

  &[data-padding='false'] {
    padding: 0;
  }
`;
